class Foo {
	bar () {
		console.log( 42 );
	}
}

export { Foo };
